import React from 'react';
import { Search, MessageCircle } from 'lucide-react';
import ConversationItem from './ConversationItem';
import { Conversation } from '../../types/wa_messages';
import { getDisplayContact } from '../../utils/messageHelpers';

interface ConversationPanelProps {
  conversations: Conversation[];
  conversationsTotal: number;
  conversationsLoading: boolean;
  conversationsError: string;
  selectedConversationId: string | null;
  search: string;
  setSearch: (search: string) => void;
  setSelectedConversationId: (id: string) => void;
}

const ConversationPanel: React.FC<ConversationPanelProps> = ({
  conversations,
  conversationsTotal,
  conversationsLoading,
  conversationsError,
  selectedConversationId,
  search,
  setSearch,
  setSelectedConversationId,
}) => {
  // Filtered conversations
  const filteredConversations = conversations.filter(c =>
    (c.pic_name || '').toLowerCase().includes(search.toLowerCase()) ||
    getDisplayContact(c.pic_contact).toLowerCase().includes(search.toLowerCase()) ||
    (c.organization_name || '').toLowerCase().includes(search.toLowerCase()) ||
    (c.xero_direct_contact_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="bg-white rounded-2xl border border-slate-200 py-4 flex flex-col w-[320px] min-w-[280px] max-w-[400px] h-full min-h-0 text-left">
      <div className="flex items-center mb-4 px-6">
        <MessageCircle className="w-6 h-6 text-slate-900 mr-2" />
        <span className="text-lg text-slate-900">Conversations</span>
      </div>
      <div className="relative mb-4 px-6">
        <span className="absolute left-10 top-3 text-slate-400"><Search className="w-4 h-4" /></span>
        <input
          type="text"
          className="w-full pl-10 pr-3 py-2 rounded-lg border border-slate-200 bg-slate-50 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-100"
          placeholder="Search conversations, contacts, or organizations..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className="flex-1 overflow-y-auto">
        {conversationsLoading ? (
          <div className="text-slate-400 text-center mt-8">Loading conversations...</div>
        ) : conversationsError ? (
          <div className="text-red-400 text-center mt-8">{conversationsError}</div>
        ) : filteredConversations.length === 0 ? (
          <div className="text-slate-400 text-center mt-8">No conversations found.</div>
        ) : (
          filteredConversations.map((conv) => (
            <ConversationItem
              key={conv.id}
              conversation={conv}
              isActive={conv.id === selectedConversationId}
              onClick={setSelectedConversationId}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationPanel; 